import React, { useState } from "react";
import Button from "../../components/Button/Button";
import { InputField1 } from "../../components/InputField1/InputField1";
import { SimpleSelect1 } from "../../components/SimpleSelect/SimpleSelect1";
import { Table } from "../../components/Table/Table";
import Typography from "../../components/Typography/Typography";
import { TagsLang } from "../../data/crmGeneralData";
import { useInsertTag, useShowTag } from "../../hooks/useCrm";
import { FiEdit } from "react-icons/fi";
import { TagsStyle } from "./TagsStyle";
import { EditTagModal } from "../../components/Dialog/EditTagModal";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
const initvalue = {
  NameTag: "",
  ColorTag: "",
  StatusTag: "",
};
const Tags = () => {
  const [form, setForm] = useState(initvalue);
  const [Search, setSearch] = useState("");
  const [tag, setTag] = useState();
  const [show, setShow] = useState(false);
  const { mutateAsync: SubmitTag, isLoading } = useInsertTag();
  const { data: tagsList, isLoading: tagsListing } = useShowTag();
  const tagsOptions = TagsLang?.map((res) => {
    return {
      value: res.value,
      label: res.label,
    };
  });
  const handleSubmit = async (data) => {
    await SubmitTag(data).then(() => setForm(initvalue));
  };

  const tagsListHeader = ["ردیف", "نام", "رنگ", "وضعیت", "عملیات"];

  const items = tagsList?.data?.tags
    ?.filter((tag) => {
      if (Search === "") {
        return tag;
      } else if (tag.SubjectTicket.includes(Search)) {
        return tag;
      }
    })
    .map((tag, index) => {
      return (
        <tr key={index}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {index + 1}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {tag.NameTag}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              <span
                className={`text-muted fw-bold text-muted d-block fs-7`}
                style={{
                  backgroundColor: `${tag.ColorTag}`,
                  height: "20px",
                  width: "30px",
                }}
              ></span>
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {tag.StatusTag === "fa"
                ? "فارسی"
                : tag.StatusTag === "en"
                ? "انگلیسی"
                : tag.StatusTag === "ar"
                ? "عربی"
                : ""}
            </span>
          </td>
          <td>
            <span className={`text-muted fw-bold text-muted d-block fs-7`}>
              <Button
                bgColor="#009ef7"
                small="fit-content"
                onclick={() => {
                  setShow(true);
                  setTag(tag);
                }}
                color="#fff"
              >
                <FiEdit />
              </Button>
            </span>
          </td>
        </tr>
      );
    });
  return (
    <>
      <BreadCrumb
        margin="mt-3"
        num1="واحد CRM"
        num2="برچسب ها"
        href1="/dashboard/crm"
      />
      <TagsStyle>
        <div className="header">
          <Typography>ثبت برچسب</Typography>
        </div>
        <div className="body">
          <div className="row p-3">
            <div className="col-lg-4 col-12">
              <InputField1
                placeholder="نام برچسب"
                label="نام برچسب"
                onChange={(e) => setForm({ ...form, NameTag: e.target.value })}
                value={form.NameTag}
              />
            </div>
            <div className="col-lg-4 col-12">
              <InputField1
                type="color"
                style={{ height: "39px" }}
                label="رنگ برچسب"
                onChange={(e) => setForm({ ...form, ColorTag: e.target.value })}
                value={form.ColorTag}
              />
            </div>
            <div className="col-lg-4 col-12">
              <SimpleSelect1
                label="زبان برچسب"
                res={tagsOptions}
                onChange={(e) => setForm({ ...form, StatusTag: e.value })}
                defaultValue={null}
              />
            </div>
            <div className="col-12 mt-2">
              <Button
                onclick={() => handleSubmit(form)}
                small="fit-content"
                bgColor="#009ef7"
                color="#fff"
              >
                {isLoading ? "در حال ثبت" : "ثبت"}
              </Button>
            </div>
          </div>
        </div>
      </TagsStyle>
      <Table
        className="mt-3"
        setSearch={setSearch}
        headerTitle={tagsListHeader}
        items={items}
        title={`برچسب ها`}
      />
      <EditTagModal show={show} handleClose={() => setShow(false)} tag={tag} />
    </>
  );
};

export default Tags;
